import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './notification.css';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

export default function Notification({ type, msg, list, closeHandler }) {
    return (
        <div className={'notification notification-' + type}>
            <div>
                {msg}
                {list && <ul className="notification-list">
                    {list.map(i => <li key={i}>{i}</li>)}
                </ul>
                }
            </div>
            <div className="notification-close">
                <button type="button" onClick={() => closeHandler(msg)}>
                    <FontAwesomeIcon icon={faXmark} />
                </button>
            </div>
        </div>
    );
}